import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postParamConfigSave = createApi(`ParamConfigSaveSlice`,"POST");

const ParamConfigSaveSlice = createSlice({
  name: 'ParamConfigSaveSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postParamConfigSave.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postParamConfigSave.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postParamConfigSave.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ParamConfigSaveSlice.reducer;